import { render, staticRenderFns } from "./ShowInclusionComponent.vue?vue&type=template&id=128ce6fc&scoped=true&"
import script from "./ShowInclusionComponent.vue?vue&type=script&lang=js&"
export * from "./ShowInclusionComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShowInclusionComponent.vue?vue&type=style&index=0&id=128ce6fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ce6fc",
  null
  
)

export default component.exports